export const types = {
  GET_ORDERS: 'GET_ORDERS',
  GET_ORDER: 'GET_ORDER',
  ADD_ORDERS: 'ADD_ORDERS',
  UPDATE_ORDER: 'UPDATE_ORDER',
  GET_DASHBOARD: 'GET_DASHBOARD',
  GET_COUNTS: 'GET_COUNTS',
  GET_REASONS: 'GET_REASONS',
  GET_MOTIVOS_INSUCESSO: 'GET_MOTIVOS_INSUCESSO',
  GET_MOTIVOS_RECUSA: 'GET_MOTIVOS_RECUSA',
  GET_MOTIVOS_CANCELAR_RETIRADA: 'GET_MOTIVOS_CANCELAR_RETIRADA',
  GET_ORDER_STATUS_HISTORY: 'GET_ORDER_STATUS_HISTORY',
  GET_ORDER_LOGS: 'GET_ORDER_LOGS',
  SET_FILTER: 'SET_FILTER',
  SET_LIMIT: 'SET_LIMIT',
  SET_RENDER: 'SET_RENDER',
  SET_DEVOLUTION: 'SET_DEVOLUTION',
  SET_MODAL_CLOSED: 'SET_MODAL_CLOSED',
  UPDATE_EVENT_IMPRIMIR_NOTA_FISCAL: 'UPDATE_EVENT_IMPRIMIR_NOTA_FISCAL',
};

export const errorToMessage = {
  DEVOLUCAO_EXPIRADA: 'Tempo máximo para devolução do pedido alcançado',
  PEDIDO_NAO_PAGO: 'Pedido não pago',
  PEDIDO_SERVICE_UPDATE_STATUS: 'Não foi possível alterar o status do pedido'
}
